module.exports = __webpack_public_path__ + "assets/img/icon3.0c3d39e2.svg";